var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.3125C3.5 5.3125 1.875 6.875 1.875 8.75C1.875 10.625 3.5 12.1875 5.5 12.1875C8.6875 12.1875 11.75 12.875 14.625 14.25L17.5 15.625V7.8125V1.875L14.5625 3.25C11.75 4.625 8.625 5.3125 5.5 5.3125Z",
    stroke: "url(#paint0_linear_1798_40711)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 11.625L6.5625 18.125H10V5.375",
    stroke: "url(#paint1_linear_1798_40711)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40711",
    x1: 9.6875,
    y1: 1.875,
    x2: 9.6875,
    y2: 15.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0905FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40711",
    x1: 6.65625,
    y1: 5.375,
    x2: 6.65625,
    y2: 18.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0905FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050399"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaign-icon.ba9ba7671eecc60baa6bc745485d33ca.svg";
export { ForwardRef as ReactComponent };